import { queryOptions, useQuery } from "@tanstack/react-query";

import { clauseGuidanceQueryKey, getClauseGuidance } from "./clauses";

export const clauseGuidanceQueryOptions = (clauseId: number) =>
    queryOptions({
        queryKey: clauseGuidanceQueryKey(clauseId),
        queryFn: () => getClauseGuidance(clauseId),
    });

export const useClauseGuidance = (clauseId: number) =>
    useQuery(clauseGuidanceQueryOptions(clauseId));
